module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image10.3040b80a.jpg";